import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import classNames from 'classnames';
import { isEqual, isEmpty, cloneDeep, uniq } from "lodash";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { ErrorText } from '../../../components';

import { CombineProductsModal, OfferModal } from "../../../components";
import ImagePlaceholder from "../../../assets/img/img_placeholder.jpg";
import Actions, { thunks } from "../../../redux/modules/products";


const TYPES = [
    {
        name: 'Category',
        value: 'category',
    },
    {
        name: 'Offers',
        value: 'offers'
    }
]

class BroadCastModal extends Component {
    constructor() {
        super()
        this.state = this.initState();
        this.resetForm = this.resetForm.bind(this);

    }
  

    initState = () => ({
        form: {
            broadCastImage: '',
            broadCastType: 'category',
            broadCastDesc: '',
        },
        errors: {},
        products: [],
        offers: [],

    })

    componentDidUpdate(prevProps) {
        const { data } = this.props;

        if (this.props.data.id && prevProps.data.id !== this.props.data.id) {
            this.setEditMode()
        }

        if (
            !isEqual(data.combinedProducts, prevProps.data.combinedProducts) &&
            data.combinedProducts &&
            data.combinedProducts.length > 0
        ) {
            this.setState((state) => ({
                products: data.combinedProducts,
            }));
        }

        this.props.reset(this.resetForm);

    }

    resetForm() {
        this.setState(this.initState())
        this.props.onHide();
     } 

    setEditMode = () => {
        const { data } = this.props;
        if (data.categoryId) {
            this.props.onCategoryChange(data.categoryId);
        }
        this.setState({
            form: {
                broadCastDesc: data.broadCastDesc,
                broadCastType: data.broadCastType,
                broadCastImage: data.broadCastImage,
            }
        })
    }

    openProductModal = () => {
        this.setState((state) => ({
            showModal: !state.showModal,
        }));
    };
    onSelectProduct = (product) => {
        const { products } = this.state;
        products.push(product);
        this.setState((state) => ({
            products,
            showModal: false,
            errors: {
                ...state.errors,
                products: "",
            },
        }));
    };
    removeProduct = (product) => {
        const { products } = this.state;
        this.setState({
            products: products.filter((p) => p.productId !== product.productId),
        });
    };

    openOfferModal = () => {
        this.setState((state) => ({
            showOfferModal: !state.showOfferModal,
        }));
    };
    onSelectOffer = (offer) => {
        const { offers } = this.state;
        offers.push(offer);
        this.setState((state) => ({
            offers,
            showOfferModal: false,
            errors: {
                ...state.errors,
                offers: "",
            },
        }));
    };

    removeOffer = (offer) => {
        const { offers } = this.state;
        this.setState({
            offers: offers.filter((o) => o.id !== offer.id),
        });
    };


    onSave = () => {
        if (!this.validateForm()) return
        const { data } = this.props;
        const { form, products, offers } = this.state;
        const body = {
            ...form,
            products: !isEmpty(products) ? uniq(products.map((product) => product.productId.toString())) : "",
            offers: !isEmpty(offers) ? uniq(offers.map((offer) => offer.id.toString())) : ""
        }
        this.props[data.id ? 'editBroadCast' : 'addBroadCast'](data.id ? { ...body, id: data.id } : body);
    }

    validateForm = () => {
        const { form } = this.state;
        const errors = {};

        // if (!form.title) errors.title = 'Required';
        if (!form.broadCastType) errors.broadCastType = 'Required';
        if (!form.broadCastImage) errors.broadCastImage = 'Required';
        else if (typeof form.broadCastImage !== 'string' && (form.broadCastImage.size / 1024 / 1024) > 10) errors.broadCastImage = 'File should be less than 10 MB.';

        this.setState({ errors });

        return isEmpty(errors)
    }

    onInputChange = e => {
        const { name, value, files } = e.target
        this.setState(state => ({
            form: {
                ...state.form,
                [name]: name === 'broadCastImage' ? files[0] : value,
            },
            errors: {
                ...state.errors,
                [name]: '',
            }
        }))
    }

    onClose = () => {
        this.setState(this.initState())
        this.props.onHide();
    }

    render() {
        const { form, errors, products, offers } = this.state;
        const { show } = this.props;
        return (
            <Modal
                show={show}
                onHide={this.onClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Broadcast
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className={classNames('mr-2', { 'text-danger': errors.broadCastImage })}>Image</label>
                                <input
                                    ref={ref => { this.fileSelector = ref }}
                                    name="broadCastImage"
                                    type="file"
                                    className="hidden"
                                    onChange={this.onInputChange}
                                />
                                <button className="btn btn-secondary" onClick={() => this.fileSelector.click()}>
                                    {form.broadCastImage ? 'Change File' : 'Select Image'}
                                </button>
                                <ErrorText error={errors.broadCastImage} />
                            </div>
                        </div>
                        <div className="col-md-12 mb-2">
                            <div className="form-group">
                                <label className={classNames({ 'text-danger': errors.broadCastDesc })}>Add Description</label>
                                <textarea
                                    name="broadCastDesc"
                                    value={form.broadCastDesc}
                                    onChange={this.onInputChange}
                                    placeholder="Title"
                                    className={classNames('form-control', { 'is-invalid': errors.broadCastDesc })}
                                    maxLength="100"
                                />
                                <ErrorText error={errors.broadCastDesc} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className={classNames({ 'text-danger': errors.broadCastType })}>Type</label>
                                <select
                                    name="broadCastType"
                                    value={form.broadCastType}
                                    onChange={this.onInputChange}
                                    className={classNames('form-control', { 'is-invalid': errors.broadCastType })}
                                >
                                    <option value="" disabled>Select</option>
                                    {TYPES.map(broadCastType => (
                                        <option key={broadCastType.value} value={broadCastType.value}>{broadCastType.name}</option>
                                    ))}
                                </select>
                                <ErrorText error={errors.broadCastType} />
                            </div>
                        </div>
                        {form.broadCastType == 'category' ? (
                            <>
                                <div className="bg-secondary p-2 col-md-12">
                                    <div className="row align-items-center">
                                        {products &&
                                            products.length > 0 &&
                                            products.map((product) => (
                                                <div key={product.productId} className="col-md-4">
                                                    <div className="bg-white d-flex m-2 p-2">
                                                        {
                                                            <img
                                                                src={
                                                                    product.productImages.length
                                                                        ? product.productImages[0]
                                                                        : ImagePlaceholder
                                                                }
                                                                alt={product.title}
                                                                width="80px"
                                                            />
                                                        }
                                                        <div className="flex-1 d-flex align-items-center">
                                                            <p className="ml-2">{product.title}</p>
                                                        </div>
                                                        <div className="center-item">
                                                            <button
                                                                className="btn btn-danger"
                                                                onClick={() =>
                                                                    this.removeProduct(product)
                                                                }
                                                            >
                                                                <i className="fa fa-trash" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        <div className="col-md-2 mt-3">
                                            <div className="form-group">
                                                {products.length == 0 &&
                                                    <button
                                                        title="Add To "
                                                        className="btn btn-xs btn-primary ml-2"
                                                        onClick={this.openProductModal}
                                                    >
                                                        <i className="fa fa-plus" />
                                                    </button>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                            : <>
                                <div className="bg-secondary p-2 col-md-12">
                                    <div className="row align-items-center">
                                        {offers &&
                                            offers.length > 0 &&
                                            offers.map((offer) => (
                                                <div key={offer.id} className="col-md-4">
                                                    <div className="bg-white d-flex m-2 p-2">
                                                        {
                                                            <img
                                                                src={
                                                                    offer.imageId
                                                                        ? offer.imageId
                                                                        : ImagePlaceholder
                                                                }
                                                                alt={offer.offerDescription}
                                                                width="80px"
                                                            />
                                                        }
                                                        <div className="flex-1 d-flex align-items-center">
                                                            <p className="ml-2">{offer.offerDescription}</p>
                                                        </div>
                                                        <div className="center-item">
                                                            <button
                                                                className="btn btn-danger"
                                                                onClick={() =>
                                                                    this.removeProduct(offer)
                                                                }
                                                            >
                                                                <i className="fa fa-trash" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        <div className="col-md-2 mt-3">
                                            <div className="form-group">
                                                {offers.length == 0 &&
                                                    <button
                                                        title="Add To "
                                                        className="btn btn-xs btn-primary ml-2"
                                                        onClick={this.openOfferModal}
                                                    >
                                                        <i className="fa fa-plus" />
                                                    </button>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={this.onClose}>Close</button>
                    <button className="btn btn-primary" onClick={this.onSave}>Save</button>
                </Modal.Footer>
                <CombineProductsModal
                    show={this.state.showModal}
                    onHide={this.openProductModal}
                    onSelect={this.onSelectProduct}
                />
                <OfferModal
                    show={this.state.showOfferModal}
                    onHide={this.openOfferModal}
                    onSelect={this.onSelectOffer}
                />
            </Modal>
        )
    }
};


const mapStateToProps = ({ products: { loading, error, data } }) => ({
    loading,
    error,
    data,
});

const mapDispatchToProps = (dispatch) => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
});

export default connect(mapStateToProps, mapDispatchToProps)(BroadCastModal);